// extracted by mini-css-extract-plugin
module.exports = {"confirmationModal":"confirmation-modal_confirmationModal__LMVfw"};